/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
import { Component, ViewEncapsulation, OnInit, ViewChild } from '@angular/core';
import { CustomerPreferenceService } from '../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../preference/customerpreference.model';
import { Router } from '@angular/router';
import { OutagesFilterComponent } from './outagesfilter.component';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { OutagesService } from '../services/outages.service';

@Component({
    selector: 'zsd-outages',
    templateUrl: '../view/outages.component.html',
    styleUrls: ['../view/outages.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class OutagesComponent implements OnInit {
    isFilterOpen: boolean;
    showOutageMenus: boolean;
    showOutagesTab: boolean;
    canCustomerViewOutages = false;
    canCusotmerViewPlannedOutages = false;
    pathUrl: string;
    loadComponentUrl: string;
    outagesResultsCount = '(0)';
    plannedOutagesResultsCount = '(0)';
    @ViewChild(OutagesFilterComponent, { static: false }) outagesFilterComponent: OutagesFilterComponent;
    constructor(private custpreferences: CustomerPreferenceService, private router: Router, private outagesService: OutagesService) {
    }

    ngOnInit() {
        this.custpreferences.getPreferenceList().toPromise()
            .then(
                (customerpreferenceResponse: CustomerPreferenceResponse) => {
                    this.canCustomerViewOutages = customerpreferenceResponse.canCustomerViewOutages;
                    this.canCusotmerViewPlannedOutages = customerpreferenceResponse.canCusotmerViewPlannedOutages;
                    this.pathUrl = this.router.url;
                    if (this.canCustomerViewOutages && this.canCusotmerViewPlannedOutages) {
                        this.showOutageMenus = true;
                        this.getCurrentOutageResultCount();
                        this.getPlannedOutageResultCount();
                    } else if (this.canCustomerViewOutages) {
                        this.getCurrentOutageResultCount();
                    } else { this.getPlannedOutageResultCount(); }

                    if (this.pathUrl.includes('/currentoutages')) {
                        this.showOutagesTab = true;
                    } else if (this.pathUrl.includes('/plannedoutages')) {
                        this.showOutagesTab = false;
                    } else if (this.pathUrl.endsWith('/outages')) {
                        if (this.canCustomerViewOutages) {
                            this.loadComponentUrl = CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT;
                            this.showOutagesTab = true;
                        } else if (this.canCusotmerViewPlannedOutages) {
                            this.loadComponentUrl = CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT;
                            this.showOutagesTab = false;
                        } else  {
                            this.loadComponentUrl = CommonConstants.STORE_COMPONENT;
                        }
                        this.router.navigate([this.loadComponentUrl]);
                    }
                }
            );
        window.scrollTo(0, 0);
    }
    getCurrentOutageResultCount() {
        this.outagesService.getOutagesCount().subscribe(
            (val: number) => {
                this.outagesResultsCount = '(' + val + ')';
            });
    }
    getPlannedOutageResultCount() {
        this.outagesService.getPlannedOutagesCount().subscribe(
            (val: number) => {
                this.plannedOutagesResultsCount = '(' + val + ')';
            });
    }

    openFilter(): void {
        this.isFilterOpen = true;
        $('#outages_filterpanel_control').width('100%');
        $('body').css('overflow-y', 'hidden');
    }

    gotoPlannedOutages(): void {
        if (this.pathUrl && this.pathUrl.includes('plannedoutages')) {
            this.router.navigateByUrl(this.pathUrl);
        } else {
            this.outagesFilterComponent.resetFilter();
            this.pathUrl = null;
            this.router.navigate([CommonConstants.OUTAGES_COMPONENT + CommonConstants.PLANNED_OUTAGES_COMPONENT]);
        }
    }
    gotToCurrentOutages(): void {
        if (this.pathUrl && this.pathUrl.includes('currentoutages')) {
            this.router.navigateByUrl(this.pathUrl);
        } else {
            this.outagesFilterComponent.resetFilter();
            this.pathUrl = null;
            this.router.navigate([CommonConstants.OUTAGES_COMPONENT + CommonConstants.CURRENT_OUTAGES_COMPONENT]);
        }
    }

}
